import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
@Pipe({
    name: 'changedateformat',
    standalone: false
})
export class ChangeDateFormatPipe implements PipeTransform {
	transform(value) {
		return moment(value).format('DD MMMM YYYY');
	}
}